<template>
  <el-tooltip effect="dark" placement="bottom">
    <div slot="content">
      点此上传名片照片，实现快捷新增;<br />
      只能上传jpg/jpeg/png/bmp文件，且不超过4M
    </div>
    <el-upload
      action="action"
      accept="jpg/jpeg/png/bmp"
      :before-upload="beforeAvatarUpload"
      :http-request="handleRequest"
      :show-file-list="false"
    >
      <el-button icon="el-icon-camera-solid" circle></el-button>
    </el-upload>
  </el-tooltip>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { country } from '@/scripts/utils';
import { uploadFileVerify } from '@/scripts/reg';

export default {
  props: {
    handleUploadSucess: Function,
  },
  data() {
    return {
      uploading: false,
    };
  },
  methods: {
    ...mapActions({
      uploadBusinessCard: 'common/uploadBusinessCard',
    }),
    async beforeAvatarUpload(file) {
      const reg = /\.(jpg|jpeg|png|bmp)$/i;
      const isImage = reg.test(file.name);
      const isLt4M = file.size / 1024 / 1024 < 4;

      if (!isImage) {
        this.$message.error('上传文件只能是图片!');
        return Promise.reject();
      }

      if (!isLt4M) {
        this.$message.error('上传图片大小不能超过 4MB!');
        return Promise.reject();
      }

      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    handleRequest(item) {
      this.uploading = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在上传中，请稍后...',
        duration: 0,
        showClose: false,
      });

      const params = new FormData();

      params.append('file', item.file);
      params.append('fileName', item.file.name);

      this.uploadBusinessCard({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 100000 },
      })
        .then((data) => {
          const res = data.data.words_result;

          const reg = /.+?(省|市|自治区|自治州|县|区)/g;
          const addressArr = res.ADDR[0] !== '' ? res.ADDR[0].match(reg) : [];

          // debugger;
          /* "words_result":{
          "PC":[""],
          "TEL":[""],
          "TITLE":[""],
          "FAX":[""],
          "EMAIL":[""],
          "URL":["wp.com"],
          "NAME":[""],
          "MOBILE":[""],
          "COMPANY":[""],
          "ADDR":[""]
          }
        */

          // 如果只有数组长度为大于0小于2， 说明只有市区，需要匹配省
          // if (addressArr.length > 0 && addressArr.length < 3 && !addressArr[0].includes('省')) {
          //   for (let i = 0; i < country.length; i += 1) {
          //     for (let j = 0; j < country[i].city.length; j += 1) {
          //       if (country[i].city[j].name === addressArr[0]) {
          //         res.province = country[i].name;
          //         break;
          //       }
          //     }
          //   }
          //   res.city = addressArr[0];
          //   res.district = addressArr[1];

          // } else
          if (addressArr && addressArr.length === 3) {
            res.province = addressArr[0] || '';
            res.city = addressArr[1] || '';
            res.district = addressArr[2] || '';
          }

          res.streetAddress = res.ADDR[0];

          res.name = res.COMPANY.filter(v => v.includes('公司')).length > 0
            ? res.COMPANY.filter(v => v.includes('公司'))[0]
            : res.COMPANY[0];
          res.department = res.COMPANY.filter(v => v.includes('部门')).length > 0
            ? res.COMPANY.filter(v => v.includes('部门'))[0]
            : res.COMPANY[0];

          this.$message({
            type: 'success',
            message: '上传成功',
          });
          this.handleUploadSucess(res);
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    // handleSuccess(response, file, fileList) {
    //   this.fileList = fileList;
    // },
  },
};
</script>
